export type OtpChannel = 'max' | 'sms';

export interface OtpCooldown {
  timestamp: number | null;
  seconds: number;
}

export type OtpCooldowns = Record<OtpChannel, OtpCooldown>;

export const createOtpCooldowns = (): OtpCooldowns => ({
  max: { timestamp: null, seconds: 0 },
  sms: { timestamp: null, seconds: 0 },
});

export const cloneOtpCooldowns = (cooldowns: OtpCooldowns): OtpCooldowns => ({
  max: { ...cooldowns.max },
  sms: { ...cooldowns.sms },
});
